export const RECEIVE_REVISIONS = 'RECEIVE_REVISIONS';
export const RECEIVE_COURSE_SCOPED_REVISIONS = 'RECEIVE_COURSE_SCOPED_REVISIONS';
export const SORT_REVISIONS = 'SORT_REVISIONS';
export const REVISIONS_LOADING = 'REVISIONS_LOADING';
export const COURSE_SCOPED_REVISIONS_LOADING = 'COURSE_SCOPED_REVISIONS_LOADING';
export const RECEIVE_REFERENCES = 'RECEIVE_REFERENCES';
export const RECEIVE_ASSESSMENTS = 'RECEIVE_ASSESSMENTS';
export const INCREASE_LIMIT = 'INCREASE_LIMIT';
export const INCREASE_LIMIT_COURSE_SPECIFIC = 'INCREASE_LIMIT_COURSE_SPECIFIC';
export const RECEIVE_REFERENCES_COURSE_SPECIFIC = 'RECEIVE_REFERENCES_COURSE_SPECIFIC';
export const RECEIVE_ASSESSMENTS_COURSE_SPECIFIC = 'RECEIVE_ASSESSMENTS_COURSE_SPECIFIC';
export const ARTICLE_FETCH_LIMIT = 500;
